import {Injectable} from '@angular/core';
import {AuthsFacade} from "@kion/data-access/data-access-auths";
import {take} from "rxjs/operators";
import {CorrelationObserverService} from "@kion/ngrx-helper";

@Injectable({
  providedIn: 'root'
})
export class AuthCheckService {

  constructor(
    private authsFacade: AuthsFacade,
    private observer:CorrelationObserverService
  ) { }


  checkTokensAndRefreshIt(): void {
    this.authsFacade.all$.pipe(take(1)).subscribe(
      auths => {
        const auth = auths.find(a => a.id === 1);
        if (auth.user) {
          this.authsFacade.deleteUserToken();
          //this.observer.subscribeToAction(this.authsFacade.deleteUserToken(),()=>window.location.reload(),()=>window.location.reload());
          return;
        }
        this.authsFacade.clearAuth();
        //this.observer.subscribeToAction(this.authsFacade.clearAuth(),()=>window.location.reload(),()=>window.location.reload());
      }
    );
  }

}
